import React, { useEffect } from 'react';
import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { loginRequest } from '../auth/authConfig';

const Login: React.FC = () => {
  const { instance } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  // Store redirect URL when component loads
  useEffect(() => {
    const redirectUrl = searchParams.get('redirect');
    if (redirectUrl) {
      localStorage.setItem('loginRedirectUrl', redirectUrl);
    }
  }, [searchParams]);

  // Check if user is already authenticated and redirect to home if needed
  useEffect(() => {
    if (isAuthenticated) {
      // Don't handle redirect here, let AuthRedirectHandler do it
      // Only redirect to home if no redirect URL is stored
      const redirectUrl = localStorage.getItem('loginRedirectUrl');
      if (!redirectUrl) {
        navigate('/', { replace: true });
      }
    }
  }, [isAuthenticated, navigate]);

  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch(error => {
      console.error('Login fehlgeschlagen:', error);
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Anmeldung erforderlich
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Bitte melde dich an, um auf diesen Bereich zuzugreifen
          </p>
        </div>
        <div className="mt-8">
          <button
            onClick={handleLogin}
            className="group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-xl text-white bg-shopware-blue hover:bg-shopware-dark-blue focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-shopware-blue"
          >
            <span className="absolute left-0 inset-y-0 flex items-center pl-3">
              <svg className="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd" />
              </svg>
            </span>
            Mit Microsoft-Konto anmelden
          </button>
        </div>
      </div>
    </div>
  );
};

export default Login; 